import { useQuery } from "@tanstack/react-query";

import { settingsApi } from "api/settingsApi";
import { findSettingValue } from "pages/Settings/settingsReadiness";

// Per-tenant "Zwroty przez Autopay" switch, edited on the Settings page.
export const useAutopayRefundsEnabled = (): boolean => {
  // Same query as the Settings page, so both share one cache entry.
  const { data } = useQuery({
    queryKey: ["settings-list"],
    queryFn: () => settingsApi.getSettingsList(),
  });
  const rows = Array.isArray(data?.data) ? data.data : [];
  return findSettingValue(rows, "autopay-refunds-enabled").trim().toLowerCase() === "true";
};
